import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@material-bank/mb3-components';
import { useAuthenticationDialog } from '@material-bank/mtag-authentication';
export function AuthenticationDialog() {
  const $ = _c(4);
  const {
    isOpen
  } = useAuthenticationDialog();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DialogContent><DialogHeader><DialogTitle>Authentication</DialogTitle><DialogDescription className="sr-only">Authentication dialog</DialogDescription>Header</DialogHeader>Content</DialogContent>;
    t1 = <DialogFooter>Footer</DialogFooter>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isOpen) {
    t2 = <Dialog open={isOpen}>{t0}{t1}</Dialog>;
    $[2] = isOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}